import React, { useEffect, useState } from 'react'
import { Card, Typography } from 'antd'
import { useStore } from 'effector-react'
import { $revisions, $totalRevisions, revisionsMounted } from './model'
import { SorterValue } from '@coreui/react-pro/src/components/smart-table/types'
import { CButton, CSmartTable } from '@coreui/react-pro'
import { path } from '../../../../libs'
import { RevisionItemFromServer } from './types'

const columns = [
  {
    key: 'lastRevisionDate',
    label: 'Date and time',
  },
  {
    key: 'daysSince',
    label: 'Last Check',
    sorter: false,
  },
  {
    key: 'name',
    label: 'Wallet',
  },
  {
    key: 'currency',
    label: 'Currency',
    sorter: false,
  },
  {
    key: 'crmBalance',
    label: 'Balance CRM',
    sorter: false,
  },
  {
    key: 'psBalance',
    label: 'Balance PS',
    sorter: false,
  },
  {
    key: 'status',
    label: 'Status',
    sorter: false,
  },
  {
    key: 'client_amount',
    label: '',
    sorter: false,
  },
]

export const RevisionList = () => {
  const [columnSorter, setColumnSorter] = useState<SorterValue>({
    column: 'lastRevisionDate',
    state: 'asc',
  })
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(200)

  const revisions = useStore($revisions)
  const totalCountOfTransactionsDetail = useStore($totalRevisions)

  useEffect(() => {
    revisionsMounted({
      limit: itemsPerPage,
      page: activePage,
      orderBy: columnSorter.column as string,
      orderDirection: columnSorter.state as string,
    })
  }, [activePage, itemsPerPage, columnSorter])

  return (
    <div className="d-flex flex-column gap-2">
      <Typography.Title level={1} className="text-dark">
        Revisions
      </Typography.Title>
      <Card style={{ width: '100%' }}>
        <CSmartTable
          columnSorter
          columns={columns}
          tableProps={{
            striped: true,
          }}
          itemsPerPage={itemsPerPage}
          itemsPerPageSelect
          onItemsPerPageChange={(itemsPerPage) => {
            setActivePage(1)
            setItemsPerPage(itemsPerPage)
          }}
          pagination={{
            external: true,
          }}
          paginationProps={{
            activePage: activePage,
            pages:
              Math.ceil(totalCountOfTransactionsDetail / itemsPerPage) || 1,
          }}
          onActivePageChange={(activePage) => setActivePage(activePage)}
          items={revisions?.map((item) => ({
            ...item,
            name: item.wallet,
          }))}
          // @ts-ignore
          onSorterChange={(sorter) => setColumnSorter(sorter)}
          scopedColumns={{
            daysSince: (item: RevisionItemFromServer) => {
              return (
                <td className="py-2">
                  {`${item.daysSince} ${
                    item.daysSince === 1 ? 'day' : 'days'
                  } ago`}
                </td>
              )
            },
            client_amount: (item: RevisionItemFromServer) => {
              return (
                <td className="py-2">
                  <CButton
                    color="link"
                    href={path.finSystem.revision.details(
                      String(item.walletId),
                      item.currency,
                    )}
                  >
                    View
                  </CButton>
                </td>
              )
            },
          }}
        />
      </Card>
    </div>
  )
}
